import React from 'react'
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import moment from 'moment';
import { Field } from 'redux-form'

const RangeStartPicker = props => {
	const { from, to } = props;
	const modifiers = { start: from, end: to };
	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);

	function changeDate(value) {
		props.handleFromChange(value);
		props.input.onChange(formatDate(value, "LL", props.localeLang));
	}

	return (
		<DayPickerInput
			value={props.input.value}
			placeholder={props.label}
			format="LL"
			formatDate={formatDate}
			parseDate={parseDate}
			dayPickerProps={{
				locale: props.localeLang,
				localeUtils: MomentLocaleUtils,
				selectedDays: [from, { from, to }],
				disabledDays: { after: to, before: tomorrow },
				toMonth: to,
				modifiers,
				numberOfMonths: 2,
				onDayClick: props.focusToEl,
			}}
			onDayChange={changeDate}
			inputProps={
				{ required: true }
			}
		/>
	)
}

const RangeEndPicker = props => {
	const { from, to } = props;
	const modifiers = { start: from, end: to };

	function changeDate(value) {
		props.handleToChange(value);
		props.input.onChange(formatDate(value, "LL", props.localeLang));
	}
	return (
		<DayPickerInput
			value={props.input.value}
			ref={props.setRef}
			placeholder={props.label}
			format="LL"
			formatDate={formatDate}
			parseDate={parseDate}
			dayPickerProps={{
				locale: props.localeLang,
				localeUtils: MomentLocaleUtils,
				selectedDays: [from, { from, to }],
				disabledDays: { before: from },
				modifiers,
				month: from,
				fromMonth: from,
				numberOfMonths: 2,
			}}
			onDayChange={changeDate}
			inputProps={
				{ required: true }
			}
		/>
	)
}	

class RenderDateRangePicker extends React.Component {
	constructor(props) {
	  super(props);
	  this.handleFromChange = this.handleFromChange.bind(this);
	  this.handleToChange = this.handleToChange.bind(this);
	  this.setRef = this.setRef.bind(this);
	  this.focus = this.focus.bind(this);
	  this.state = {
		from: undefined,
		to: undefined,
	  };
	}
	showFromMonth() {
	  const { from, to } = this.state;
	  if (!from) {
		return;
	  }
	  if (moment(to).diff(moment(from), 'months') < 2) {
		this.toEl.getDayPicker().showMonth(from);
	  }
	}
	handleFromChange(from) {
	  this.setState({ from });
	}
	handleToChange(to) {
	  this.setState({ to }, this.showFromMonth);
	}
	setRef(input) {
		this.toEl = input;
	}
	focus() {
		this.toEl.getInput().focus()
	}
	render() {
	  const { from, to } = this.state;
	  return (
		<div className="InputFromTo">
			<Field
				name="desiredStartDate"
				component={RangeStartPicker}
				label={this.props.startLabel}
				localeLang="en"
				from={from}
				to={to}
				focusToEl={this.focus}
				handleFromChange={this.handleFromChange}
			/>
		  <span className="InputFromTo-to ml-4">
		  	<Field
				name="desiredEndDate"
				component={RangeEndPicker}
				label={this.props.endLabel}
				localeLang="en"
				from={from}
				to={to}
				handleToChange={this.handleToChange}
				setRef={this.setRef}
			/>
		  </span>
		</div>
	  );
	}
  }

export default RenderDateRangePicker


// WEBPACK FOOTER //
// ./src/components/fields/renderDateRangePicker.js